import React from 'react';
import { Box, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import OfflineBanner from 'components/feedback/OfflineBanner';
import WhatsAppFab from 'components/feedback/WhatsAppFab';
import CookieBanner from 'components/feedback/CookieBanner';
import TenantHead from 'components/seo/TenantHead';

const StoreLayout: React.FC = () => (
  <Box display="flex" flexDirection="column" minHeight="100vh" bgcolor="background.default">
    <TenantHead />
    <OfflineBanner />
    <Header />
    <Container component="main" maxWidth="lg" sx={{ flexGrow: 1, py: { xs: 2, md: 3 } }}>
      <Outlet />
    </Container>
    <Footer />
    <WhatsAppFab />
    <CookieBanner />
  </Box>
);

export default StoreLayout;
